import type { CardQuality } from '__generated__/globalTypes';
import { StarRank } from 'components/card/StarRank';

type Props = { dropRank: number };
export const DropRank = ({ dropRank }: Props) => {
  const starRank = Math.abs(dropRank - 6);
  const cardQuality = `TIER_${dropRank}` as CardQuality;
  return <StarRank starRank={starRank} cardQuality={cardQuality} />;
};
